module.exports = __webpack_public_path__ + "img/1.268c5a24.png";